module.exports = __webpack_public_path__ + "media/exploded_and_closeup_fade.5afa5899.mp4";